/*jshint esversion: 8 */
import { fetchPost } from './RequestHandler';


// 查询开发商
const getDevelopers = async (data) => {
  const rst = await fetchPost('/web_developer/getDevelopers', { data });
  return rst;
};



// 添加开发商
const addDeveloper = async (data) => {
  const rst = await fetchPost('/web_developer/addDeveloper', { data });
  return rst;
};

// 删除开发商
const deleteDeveloper = async (data) => {
  const rst = await fetchPost('/web_developer/deleteDeveloper', { data });
  return rst;
};






// 查询开发商销售
const getDeveloperUsers = async (data) => {
  const rst = await fetchPost('/web_developer/getDeveloperUsers', { data });
  return rst;
};

// 新增开发商销售
const addDeveloperUser = async (data) => {
  const rst = await fetchPost('/web_developer/addDeveloperUser', { data });
  return rst;
};



// 修改开发商销售
const updateDeveloperUser = async (data) => {
  const rst = await fetchPost('/web_developer/updateDeveloperUser', { data });
  return rst;
};


// 删除开发商销售
const deleteDeveloperUser = async (data) => {
  const rst = await fetchPost('/web_developer/deleteDeveloperUser', { data });
  return rst;
};


export {
  getDevelopers,
  addDeveloper,
  deleteDeveloper,

  getDeveloperUsers,
  addDeveloperUser,
  updateDeveloperUser,
  deleteDeveloperUser
};
